import {ArrowIcon} from '@prtimes-basis/icons';
import styles from './pc-footer.module.css';

export function PcFooter() {
  return (
    <div className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.listsWrapper}>
          <div>
            <p className={styles.title}>ニュースリリース配信サービス</p>
            <ul className={styles.list}>
              {serviceData.map((item) => (
                <li key={item.text}>
                  <p className={styles.listLink}>{item.text}</p>
                </li>
              ))}
              <li key='ログイン'>
                <span className={styles.listLink}>ログイン</span>
              </li>
            </ul>
          </div>
          <div>
            <p className={styles.title}>レコメンドサービス</p>
            <ul className={styles.list}>
              {recommendData.map((item) => (
                <li key={item.text}>
                  <p className={styles.listLink}>{item.text}</p>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className={styles.title}>PR TIMES公式SNS</p>
            <ul className={styles.list}>
              <li>
                <p className={styles.listLink}>公式Facebookページ</p>
              </li>
              <li className={styles.dropdownTrigger}>
                <span>Facebookカテゴリ</span>
                <ArrowIcon variant='gray' direction='down' />
              </li>
              <li>
                <p className={styles.listLink}>公式Xページ</p>
              </li>
              <li className={styles.dropdownTrigger}>
                <span>Xカテゴリ</span>
                <ArrowIcon variant='gray' direction='down' />
              </li>
            </ul>
          </div>
        </div>
        <section className={styles.footerFooter}>
          <ul className={styles.footerList}>
            {footerData.map((item) => (
              <li key={item.text} className={styles.footerListItem}>
                <p className={styles.listLink}>{item.text}</p>
              </li>
            ))}
          </ul>
        </section>
        <small className={styles.copyright}>
          Copyright &copy; PR TIMES Corporation All Rights Reserved.
        </small>
      </div>
    </div>
  );
}

const serviceData = [
  {
    text: 'PR TIMESとは',
    href: '/service',
  },
  {
    text: '料金・プラン',
    href: '/price',
  },
  {
    text: 'プレスリリースを受信したい方へ',
    href: '/user_info',
  },
  {
    text: 'プレスリリースを配信したい方へ',
    href: '/main/registcorp/form',
  },
];

const recommendData = [
  {
    text: 'PR TIMES STORY',
    href: '/story',
  },
  {
    text: '動画制作・動画PRならPR TIMES TV',
    href: '/tv/info_tv?utm_source=prtimes&utm_medium=footer',
  },
  {
    text: '記者発表・イベント配信ならPR TIMES LIVE',
    href: '/tv/info_live?utm_source=prtimes&utm_medium=footer',
  },
  {
    text: 'PR TIMES MAGAZINE',
    href: '/magazine',
  },
  {
    text: '広報PRの効果測定はWebクリッピング',
    href: '/webclipping/service/',
    isExternal: true,
  },
  {
    text: 'タスク・プロジェクト管理ならJooto',
    href: 'https://www.jooto.com/',
    isExternal: true,
  },
  {
    text: '無料フォーム・FAQならTayori',
    href: 'https://tayori.com/feature/faq',
    isExternal: true,
  },
  {
    text: 'PR事例ならPR EDGE',
    href: 'https://predge.jp/',
    isExternal: true,
  },
];

const footerData = [
  {
    text: '会社概要',
    href: '/main/html/company',
  },
  {
    text: 'プライバシーポリシー',
    href: 'https://prtimes.co.jp/policy/',
  },
  {
    text: 'PR TIMESコンテンツ掲載基準',
    href: 'https://tayori.com/faq/89b604344ebb744dbba41f73d4134560c997a743',
    isExternal: true,
  },
  {
    text: '利用規約',
    href: '/main/html/kiyaku',
    isExternal: true,
  },
  {
    text: '報道関係者様からのお問い合わせ',
    href: 'https://tayori.com/form/c5788940efb74672cc13bd2cb1d8587b3f20fcb8',
    isExternal: true,
  },
  {
    text: '企業様からのお問い合わせ',
    href: 'https://tayori.com/form/536e9f54c53fb0fa255e36237e66a8c50e2cd625',
    isExternal: true,
  },
  {
    text: '一般の皆様からのお問い合わせ',
    href: 'https://tayori.com/form/81416340de36e393af7b2d7e6e707112d77c06d4',
    isExternal: true,
  },
];
